import { BrowserRouter, useRoutes } from "react-router-dom";
import type { RouteObject } from "react-router-dom";

import { routes } from "@/routes";
import { AuthGuard } from "@/modules/auth";
import { RequestLoading } from "@/shared/components";

function AppRoutes() {
  return useRoutes(routes as RouteObject[]);
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthGuard>
        <AppRoutes />
      </AuthGuard>
      <RequestLoading />
    </BrowserRouter>
  );
}
